'use strict';

module.exports.PLAY = {
		type: 'PLAY',
		name: 'SVT Play'
};

module.exports.FLOW = {
		type: 'FLOW',
		name: 'SVT Flow'
};

module.exports.KIDS = {
		type: 'KIDS',
		name: 'Barnkanalen'
};

module.exports.OPEN_ARCHIVE = {
		type: 'OPEN_ARCHIVE',
		name: 'Öppet arkiv'
};



/** WEBPACK FOOTER **
 ** ./app/utils/destinations.js
 **/